import { GET_WORKFLOWS_LIST, GET_WORKFLOWS_LIST_SUCCESS, GET_WORKFLOWS_LIST_ERROR, GET_WORKFLOWS_LIST_EMPTY } from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetWorkflowsList = (state = initialState, action) => {
  switch (action.type) {
    case GET_WORKFLOWS_LIST:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_WORKFLOWS_LIST_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_WORKFLOWS_LIST_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_WORKFLOWS_LIST_EMPTY:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetWorkflowsList;
